import { render, staticRenderFns } from "./SubmissionReviewCard.vue?vue&type=template&id=0e5122a8"
import script from "./SubmissionReviewCard.vue?vue&type=script&lang=js"
export * from "./SubmissionReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports